module.exports = __webpack_public_path__ + "static/media/figure-main-background-2.613a28ff.svg";